import styled from 'styled-components';

export default {
    Modal: styled.div.attrs({ className: 'modal' })`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100%;
        background: rgba(66, 65, 65, 0.6);
        z-index: 101;
        overflow-y: auto;
    `,
    ModalContent: styled.div.attrs({ className: 'modal-content' })`
        font-family: Noto Sans;
        position: relative;
        background-color: #fff;
        z-index: 110;
        box-shadow: 0 2px 5px rgba(0,0,0,0.5);
        top: 108px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        min-height: 368px;
        height: auto;
        width: 92vw;
        padding-left: 24px;
        padding-right: 24px;
        padding-top: 47px;
        padding-bottom: 55px;
        box-shadow: 0px 5px 40px rgba(0, 0, 0, 0.3);
        box-sizing: border-box;
        @media (max-width: 320px) {
            width: 310px;
        }
        @media (min-width: 700px) {
            width: 540px;
        }
        @media (min-width: 1000px) {
            width: 980px;
            border-radius: 5px;
            height: 450px;
            top: 230px;
            padding-left: 120px;
            padding-right: 120px;
            padding-top: 89px;
            padding-bottom: 30px;
        }
    `,
    ModalTitle: styled.h3.attrs({ className: 'modal-title' })`
        font-family: 'Toyota Display Bold';
        font-size: 24px;
        font-weight: Bold;
        line-height: 24px;
        letter-spacing: -1.32px;
        display: block;
        text-align: center;
        padding: 0;
        margin: 0;
        text-align: left;
        @media (min-width: 1000px) {
            font-size: 36px;
            line-height: 46px;
        }
    `,
    ModalTextContainer: styled.div.attrs({ className: 'modal-text-container' })`
        max-width: 839px;
        margin: 20px 0 16px;
        min-height: 82px;
        max-height: 342px;
        overflow-y: auto;
        @media (min-width: 1000px) {
            margin: 10px 0 30px;
        }
    `,
    ModalText: styled.p.attrs({ className: 'modal-text' })`
        width: 100%;
        font-family: Noto Sans;
        font-size: 16px;
        color: #202020;
        text-align: left;
        font-family: Toyota Display;
    `,
    InputError: styled.span.attrs({ className: 'input-error' })`
        position: absolute;
        bottom: -20px;
        font-family: Noto Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 30px;
        color: #E50000;
        @media (min-width: 1000px) {
            font-size: 18px;
            line-height: 30px;
        }
    `,
};
